
import { SalaryTimeEntry, PDFTableRow } from "./types";
import { formatDate, formatTime, roundTo5Rappen } from "./formatters";
import { calculateDayTotalMinutes } from "./calculators";
import { PDF_CONFIGS } from "./constants";

export const generateTimeTableData = (
  entriesByDate: Record<string, SalaryTimeEntry[]>,
  hourlyRate: number
): PDFTableRow[] => {
  return Object.entries(entriesByDate).flatMap(([date, dayEntries]) => {
    // Sort entries by start time for the day
    dayEntries.sort((a, b) => new Date(a.start_time).getTime() - new Date(b.start_time).getTime());

    // Calculate break time for the day
    const totalMinutesForDay = calculateDayTotalMinutes(dayEntries);
    const hoursForDay = totalMinutesForDay / 60;
    const shouldAddBreak = hoursForDay > PDF_CONFIGS.BREAK_THRESHOLD_HOURS;
    
    // Add individual entries
    return dayEntries.map(entry => {
      if (!entry.end_time) return [];
      
      const startTime = new Date(entry.start_time);
      const endTime = new Date(entry.end_time);
      const durationInMinutes = (endTime.getTime() - startTime.getTime()) / (1000 * 60);
      const hours = durationInMinutes / 60;
      let amount = roundTo5Rappen(hours * hourlyRate);
      
      // If this is the last entry of the day and we need to subtract break time
      if (shouldAddBreak && entry === dayEntries[dayEntries.length - 1]) {
        const breakAdjustedHours = hours - (PDF_CONFIGS.BREAK_DURATION_MINUTES / 60);
        amount = roundTo5Rappen(breakAdjustedHours * hourlyRate);
        return [
          formatDate(startTime),
          formatTime(startTime),
          formatTime(endTime),
          `${PDF_CONFIGS.BREAK_DURATION_MINUTES} min`,
          breakAdjustedHours.toFixed(2),
          amount.toFixed(2)
        ];
      }

      return [
        formatDate(startTime),
        formatTime(startTime),
        formatTime(endTime),
        "-",
        hours.toFixed(2),
        amount.toFixed(2)
      ];
    }).filter(entry => entry.length > 0) as PDFTableRow[];
  });
};
